import {
  composeRenderProps,
  Button as RACButton,
  type ButtonProps as RACButtonProps
} from "react-aria-components";
import { tv } from "tailwind-variants";
import { focusRing } from "./utils";

export interface ButtonProps extends RACButtonProps {
  /** @default 'primary' */
  variant?: "primary" | "secondary" | "outline" | "destructive" | "icon" | "link";
  size?:
    | "default"
    | "sm"
    | "lg"
    | "xl"
    | "2xl"
    | "3xl"
    | "icon_xs"
    | "icon"
    | "icon_xl"
    | "icon_lg";
}

const button = tv({
  extend: focusRing,
  base: "cursor-pointer inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0",
  variants: {
    variant: {
      primary: "bg-primary text-primary-foreground shadow hover:bg-primary/90",
      destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
      outline:
        "border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground",
      secondary: "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
      link: "text-primary underline-offset-4 hover:underline",
      icon: "hover:bg-accent hover:text-accent-foreground"
    },
    size: {
      default: "h-9 px-4 py-2",
      sm: "h-8 px-2 text-xs",
      lg: "h-10 px-4",
      xl: "h-12 px-4",
      "2xl": "h-14 px-4",
      "3xl": "h-16 px-4",
      icon_xs: "size-6",
      icon: "size-8",
      icon_lg: "size-10",
      icon_xl: "size-12"
    },
    isDisabled: {
      true: "opacity-50 pointer-events-none"
    }
  },
  defaultVariants: {
    variant: "primary",
    size: "default"
  }
});

export function Button(props: ButtonProps) {
  return (
    <RACButton
      {...props}
      className={composeRenderProps(props.className, (className, renderProps) =>
        button({ ...renderProps, variant: props.variant, size: props.size, className })
      )}
    />
  );
}
